import classNames from 'classnames';
import { FC } from 'react';
import { ChildrenPropType } from 'src/utils/types';

type Props = {
  children: ChildrenPropType;

  className?: string;
};

/**
 * for pages that are almost SPA
 * it should be in <body
 */
export const BaseLayout: FC<Props> = ({ children, className }) => (
  <div
    id="container"
    className={classNames(
      'orig-body-container PrimaryPageBackground PrimaryPageBackgroundText r-baselayout',
      className
    )}
  >
    {children}
  </div>
);
